
import { useRoute, useRouter } from "vue-router/composables";
import { addEbookView } from '@/api/index.js';

    export default function useGoDetail() {
        const router = useRouter();
        // 进入图书详情页
        const handleDetail = (item) => {
            addEbookView({ id: item.id });
            router.push('/bookDetail?id=' + item.id);
        };
        return { handleDetail };
    }

